import { PlanCategory } from "../../types/Plan";
import DB_PATH from "../DB_PATH";
import firebase from "firebase/app";
import "firebase/firestore";

async function createCategory({ communityId, name, position }) {
  const db = firebase.firestore();
  const categoryRef = db
    .collection(DB_PATH.COMMUNITY)
    .doc(communityId)
    .collection(DB_PATH.PLAN_CATEGORIES);

  // Generate a new document ID
  const newDocRef = categoryRef.doc();

  const newCategory = {
    id: newDocRef.id, // Include the ID in the document
    isActive: true,
    name,
    position,
    imageURL: "",
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
  };

  console.log("CategoryCreated", newCategory);

  try {
    // Set the document with the generated ID
    await newDocRef.set(newCategory);
    return newCategory;
  } catch (error) {
    console.error("Error creating category: ", error);
    throw error;
  }
}

export default createCategory;
